import instance from "../../../config/axios";
import url from "../../../constants/url";

const gcitem = "gcitem";
const gcBlendsheetDetails = "gc-blendsheet-list";
const gcItemBinDetails = "gc-item-bin-details";
const gcItemDispenseDetails = "gc-item-dispense-details";
const gcStatusList = "gc-status-list";
const gcGridList = "gc-grid-list";
const gcGroupsList = "gc-groups-list";
const gcInventoryDetails = "gc-inventory-details";
const gcItemTypeList = "gc-item-type-list";
const gcItemCategoryList = "gc-item-category-list";
const gcItemShortCodes = "gc-item-short-codes";
const gcItemGroupList = "gc-item-group-list";
const gcItemClassificationList = "gc-item-classification-list";
const gcUOMList = "gc-uom-list";
const createGC = "create-gc";
const updateGC = "update-gc";
const details = "details";
const gcAllocationList = "gc-allocation-list";
const gcInventoryList = 'gc-inventory-details';
const gcEnquiryList = 'gc-enquiry-list';
const gcDailyRatesList = 'gc-daily-rate-list';
const gcPoList = 'gc-po-list';
const gcMrinList = 'gc-mrin-list';
const gcTypeSampleList = 'gc-type-sample-list';
const gcPreShipmentList = 'gc-pre-shipment-list';

const typePreshipmentSampleModule = "type-preshipment-sample-module";
const typeSampleLineList = "type-sample-line-list";
const preshipmentSampleLineList = "pre-shipment-sample-line-list";

// get Dispense Information list
export const getDispenseInfo = async(data) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcBlendsheetDetails}`,data)
      return res;
};

// getbin details
export const getBinDetails = async(data) => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcItemBinDetails}/${data}`)
      return res;
}

// get the dispense information
export const getDispenseInformationData = async(data) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcItemDispenseDetails}`, data)
      return res;
}

export const getViewPickList = async(data) => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcStatusList}`)
      return res;
}

export const getGCGridList = async(data) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcGridList}`, data)
      return res;
}

export const getGCGroupsList = async(category_name) => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcGroupsList}/${category_name}`)
      return res;
}

// get list of inventory
export const getGCInventoryList = async(payload, signal) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcInventoryDetails}`, payload, { signal })
      return res;
}

// get list of item type
export const getItemTypeListData = async() => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcItemTypeList}`)
      return res;
}

// get list of item category
export const getItemCategoryListData = async() => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcItemCategoryList}`)
      return res;
}

// get list of short codes
export const getItemShortCodesListData = async() => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcItemShortCodes}`)
      return res;
}

// get list of item group
export const getItemGroupListData = async() => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcItemGroupList}`)
      return res;
}

// get list of classification
export const getItemClassificationListData = async() => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcItemClassificationList}`)
      return res;
}

// get list of UOM
export const getUOMListData = async() => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${gcUOMList}`)
      return res;
}

// create gc
export const getCreateGC = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${createGC}`, payload)
      return res;
}

// update gc
export const getUpdateGC = async(payload) => {
  const res = instance
    .put(`${url.packagingapiurl}${gcitem}/${updateGC}`, payload)
      return res;
}

// get gc details
export const getGCDetails = async(id,company,signal) => {
  const res = instance
    .get(`${url.packagingapiurl}${gcitem}/${details}/${id}?company_name=${company}`, { signal })
      return res;
}

// allocation detail
export const getGCAllocationDetails = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcAllocationList}`, payload)
      return res;
}

// inventory detail
export const getGCInventoryDetails = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcInventoryList}`, payload)
      return res;
}

// enquiry detail
export const getGCEnquiryDetails = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcEnquiryList}`, payload)
      return res;
}

// gc daily rates
export const getGCDailyuRatesDetails = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcDailyRatesList}`, payload)
      return res;
}

// gc PO list
export const getGCPOList = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcPoList}`, payload)
      return res;
}

// gc MRIN list
export const getGCMRINList = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcMrinList}`, payload)
      return res;
}

// gc Type Sample list (parent rows for TypeSampleInfo tab)
export const getGCTypeSampleList = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcTypeSampleList}`, payload)
      return res;
}

// gc Pre-Shipment Sample list (parent rows for PreshipmentSampleInfo tab)
export const getGCPreShipmentList = async(payload) => {
  const res = instance
    .post(`${url.packagingapiurl}${gcitem}/${gcPreShipmentList}`, payload)
      return res;
}

// gc Type Sample line list (child rows, lazy-loaded on row expand)
export const getGCTypeSampleLineList = async(record_id) => {
  const res = instance
    .get(`${url.packagingapiurl}${typePreshipmentSampleModule}/${typeSampleLineList}/${encodeURIComponent(record_id)}`)
      return res;
}

// gc Pre-Shipment Sample line list (child rows, lazy-loaded on row expand)
export const getGCPreShipmentLineList = async(record_id) => {
  const res = instance
    .get(`${url.packagingapiurl}${typePreshipmentSampleModule}/${preshipmentSampleLineList}/${encodeURIComponent(record_id)}`)
      return res;
}
